/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download YouTube video thumbnails in every resolution — HD, SD and more — from any video URL. Free, no signup.`)
};

const es_yt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga miniaturas de videos de YouTube en todas las resoluciones — HD, SD y más — desde cualquier URL de video. Gratis, sin registro.`)
};

const de_yt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade YouTube-Video-Thumbnails in jeder Auflösung herunter — HD, SD und mehr — von jeder Video-URL. Kostenlos, keine Anmeldung nötig.`)
};

const nl_yt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download YouTube-videothumbnails in elke resolutie — HD, SD en meer — van elke video-URL. Gratis, geen account nodig.`)
};

const fr_yt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargez les miniatures de vidéos YouTube dans toutes les résolutions — HD, SD et plus — à partir de n’importe quelle URL de vidéo. Gratuit, sans inscription.`)
};

const it_yt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica le miniature dei video YouTube in ogni risoluzione — HD, SD e altre — da qualsiasi URL video. Gratis, senza registrazione.`)
};

const pt_br2_yt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixe thumbnails de vídeos do YouTube em todas as resoluções — HD, SD e mais — a partir de qualquer URL de vídeo. Grátis, sem cadastro.`)
};

const pt_yt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregue miniaturas de vídeos do YouTube em todas as resoluções — HD, SD e mais — a partir de qualquer URL de vídeo. Grátis, sem registo.`)
};

const ja_yt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意の動画URLから、HD・SDなどあらゆる解像度でYouTube動画のサムネイルをダウンロード。無料、登録不要。`)
};

const zh_yt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从任意视频链接下载 YouTube 视频缩略图，支持 HD、SD 等所有分辨率。免费，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_tool_description", locale)
	if (locale === "en") return en_yt_tool_description(inputs)
	if (locale === "es") return es_yt_tool_description(inputs)
	if (locale === "de") return de_yt_tool_description(inputs)
	if (locale === "nl") return nl_yt_tool_description(inputs)
	if (locale === "fr") return fr_yt_tool_description(inputs)
	if (locale === "it") return it_yt_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_yt_tool_description(inputs)
	if (locale === "pt") return pt_yt_tool_description(inputs)
	if (locale === "ja") return ja_yt_tool_description(inputs)
	return zh_yt_tool_description(inputs)
};